(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/sbtech-api-impl.js') >= 0) return;  svs.modules.push('/modules/sportsbook/components/sbtech-api-impl/assets/javascripts/sbtech-api-impl.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  fns: {
    requests: requestFunctions,
    actions: actionFunctions
  },
  logger,
  betslip,
  yourbet
} = svs.sportsbook.sbtech_api_impl;
const {
  setIframeHeight
} = svs.sportsbook.sbtech_api_impl.utils;
let initialized = false;
svs.sportsbook.sbtech_api_impl.init = (sbtechIframe, sbtechOrigin, token) => {
  if (!sbtechIframe || sbtechIframe.tagName !== 'IFRAME') {
    throw new Error('Element is not an iframe');
  }
  if (!sbtechOrigin) {
    throw new Error('No origin provided');
  }
  if (initialized) {
    throw new Error('SBTech api is already initialized');
  }
  if (svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER) && !token) {
    throw new Error('Missing mandatory token');
  }

  const getToken = () => svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER) ? token : null;
  const internals = {
    getToken,
    iframe: sbtechIframe,
    stats: null
  };
  const requests = Object.keys(requestFunctions).reduce((acc, fn) => _objectSpread(_objectSpread({}, acc), {}, {
    [fn]: requestFunctions[fn](data => sbtechIframe.contentWindow.postMessage({
      data,
      name: fn
    }, sbtechOrigin), internals)
  }), {});
  const actions = Object.keys(actionFunctions).reduce((acc, fn) => _objectSpread(_objectSpread({}, acc), {}, {
    [fn]: actionFunctions[fn](data => sbtechIframe.contentWindow.postMessage({
      data,
      name: fn
    }, sbtechOrigin), internals)
  }), {});
  const handleClickSportsbookBetslip = () => {
    const topContentHeight = (document.querySelector('.js-fixed-top-content') || {}).clientHeight || 0;
    actions.goToResponsiveBetSlipCallback();
    window.scrollTo(0, sbtechIframe.offsetTop - topContentHeight);
  };
  const handleSportsbookBetslipStateChange = () => {
    setIframeHeight(sbtechIframe);
  };
  const destroyBetslip = betslip.render(handleClickSportsbookBetslip, handleSportsbookBetslipStateChange);
  const handleClickYourBetButton = () => {
    const topContentHeight = (document.querySelector('.js-fixed-top-content') || {}).clientHeight || 0;
    actions.goToBetBuilderCallback();
    window.scrollTo(0, sbtechIframe.offsetTop - topContentHeight);
  };
  const destroyYourBetButton = yourbet.render(handleClickYourBetButton, sbtechIframe);
  const messageEvent = _ref => {
    let {
      data,
      origin
    } = _ref;
    if (origin !== sbtechOrigin) {
      return;
    }
    const fn = requests[data.name];
    if (fn) {
      fn(data.data);
    } else {
      logger.debug("Receiving event not responding to", data);
    }
  };
  const destroy = () => {
    window.removeEventListener('message', messageEvent);
    destroyBetslip();
    destroyYourBetButton();
    initialized = false;
  };
  window.addEventListener('message', messageEvent);
  initialized = true;
  window.requestIdleCallback(() => {
    const stats = svs.sportsbook.statistics.init();
    internals.stats = stats;
  });
  return {
    actions,
    destroy
  };
};

 })(window);